import { jsx, Fragment, jsxs } from "react/jsx-runtime";
import { useClassNameFactory } from "@contember/react-utils";
import { PlusIcon } from "lucide-react";
import { Button } from "../Button/Button.js";
const SelectCreateNewWrapper = ({ onClick, children }) => {
  const componentClassName = useClassNameFactory("selectCreateNewWrapper");
  if (!onClick) {
    return /* @__PURE__ */ jsx(Fragment, { children });
  }
  return /* @__PURE__ */ jsxs("div", { className: componentClassName(), children: [
    /* @__PURE__ */ jsx("div", { className: componentClassName("control"), children }),
    /* @__PURE__ */ jsx("div", { className: componentClassName("button"), children: /* @__PURE__ */ jsx(Button, { square: true, onClick, intent: "default", children: /* @__PURE__ */ jsx(PlusIcon, {}) }) })
  ] });
};
export {
  SelectCreateNewWrapper
};
//# sourceMappingURL=SelectCreateNewWrapper.js.map
